import '../../../filtersGrid.scss';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useMediaQuery } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import TextField from '@mui/material/TextField'; // Importa TextField de MUI
import IconButton from '@mui/material/IconButton'; // Importa IconButton de MUI
import ClearIcon from '@mui/icons-material/Clear'; // Icono de la cruz
import SearchButton from '../../../../components/SearchButton/SearchButton';
import EmpleadosModal from '../../../empleados/empleadosModal/empleadosModal';
import DepositosModal from '../../../depositos/depositosModal/depositosModal';

Modal.setAppElement('#root');
dayjs.locale('es');
const FiltersGrid = ({
  searchInputRef, 
  searchTerm,
  searchDescFilter,
  searchDescSecondFilter,
  dateFromFilter,
  dateUntilFilter,
  setSearchTerm,
  setSearchIDFilter,
  setSearchDescFilter,
  setSearchIDSecondFilter,
  setSearchDescSecondFilter,
  setDateFromFilter,
  setDateUntilFilter,
  onSearch, 
  onClose,
}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    if (!isSmallScreen) {
      setIsModalOpen(false); // Cierra el modal al cambiar a pantallas grandes
    }
  }, [isSmallScreen]);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleClearDateFrom = () => {
    setDateFromFilter(null); // Limpiar la fecha "Desde"
  };

  const handleClearDateUntil = () => {
    setDateUntilFilter(null); // Limpiar la fecha "Hasta"
  };
  const handleClearFilters = () => {
    setSearchTerm?.("");
    setSearchIDFilter?.("");
    setSearchDescFilter?.("");
    setSearchIDSecondFilter?.("");
    setSearchDescSecondFilter?.("");
    setDateFromFilter(null);
    setDateUntilFilter(null);
  };

  const renderInputs = () => (
      <SearchButton
        searchInputRef={searchInputRef}
        searchTerm={searchTerm} 
        onSearch={onSearch}
        onClose={onClose}
        tipo={3}
      />
  )
  const renderDateInputs = () => (
    <>
      <div className="dateInput">
        <DatePicker
          label="Fecha Desde"
          value={dateFromFilter ? dayjs(dateFromFilter) : null} // Usa dayjs si es necesario
          onChange={(newValue) => {
            setDateFromFilter(newValue ? newValue.format('YYYY-MM-DD') : null); // Convierte a 'YYYY-MM-DD' solo si es necesario
          }}
          format="DD/MM/YYYY"
          renderInput={(params) => (
            <div className="datePickerWrapper">
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      <IconButton onClick={handleClearDateFrom}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </>
                  ),
                }}
              />

            </div>
          )}
        />
      </div>
      <div className="dateInput">
        <DatePicker
          label="Fecha Hasta"
          value={dateUntilFilter ? dayjs(dateUntilFilter) : null}
          onChange={(newValue) => {
            setDateUntilFilter(newValue ? newValue.format('YYYY-MM-DD') : null); // Convierte a 'YYYY-MM-DD' solo si es necesario
          }}
          format="DD/MM/YYYY"
          sx={{
            width: '160px',
          }}
          renderInput={(params) => (
            <div className="datePickerWrapper">
              <TextField
                {...params}

                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {params.InputProps.endAdornment}
                      <IconButton onClick={handleClearDateUntil}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </>
                  ),
                }}
              />

            </div>
          )}
        />
      </div>
    </>
  );

  const renderModals = () => (

    <>
    
      {renderDateInputs()}
      {renderInputs()}
      <EmpleadosModal
        handleChange={(id) => setSearchIDFilter(id)}
        handleDescChange={(desc) => setSearchDescFilter(desc)}
        descSelected={searchDescFilter}
      />
      <DepositosModal
        handleChange={(id) => setSearchIDSecondFilter(id)}
        handleDescChange={(desc) => setSearchDescSecondFilter(desc)}
        descSelected={searchDescSecondFilter}
      /> 
    </>
  );


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">

      <div className="filterContainer">
        {isSmallScreen ? (
          <>
            <button className="filterButton" onClick={handleOpenModal}>
              Filtros De Búsqueda
            </button>

            <Modal
              isOpen={isModalOpen}
              onRequestClose={handleCloseModal}
              contentLabel="Seleccionar Filtros"
              className="modalScreen"
              overlayClassName="overlayScreen"
            >
              <h2>Filtros de Búsqueda</h2>
              <div className="modalContent">
                {renderModals()}
              </div><div className="filtersActions">
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>
              <button className="modalCloseButton" onClick={handleCloseModal}>
                ❌
              </button>
            </Modal>
          </>
        ) : (
          <>
          
    <div className="searchContainer">
              {renderModals()}
               <div className="filtersActions">
              <button
                type="button"
                className="clearFiltersButton"
                onClick={handleClearFilters}
              >
                Limpiar filtros
              </button>
            </div>
    </div>
          </>
        )}
      </div>
    </LocalizationProvider>
  );
};

export default FiltersGrid;
